var __jsx = React.createElement;
import React from 'react';
var WarrningLimit = function WarrningLimit() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "96",
    height: "82",
    viewBox: "0 0 96 82",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M96 33.3968V47.9778C96 72.2794 86.4 82 62.4 82H33.6C9.6 82 0 72.2794 0 47.9778V33.3968C0 12.9929 6.768 2.88732 23.136 0.144366H24L72 0C88.992 2.50234 96 12.6561 96 33.3968Z",
    fill: "#FDEFEB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "heroicons-micro/exclamation-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M42.7638 19.8382C45.091 15.8074 50.909 15.8074 53.2362 19.8382L74.1809 56.1156C76.5081 60.1464 73.5991 65.1849 68.9447 65.1849H27.0552C22.4009 65.1849 19.4919 60.1464 21.8191 56.1156L42.7638 19.8382ZM48 26.8921C49.6696 26.8921 51.0231 28.2456 51.0231 29.9152V42.0077C51.0231 43.6773 49.6696 45.0308 48 45.0308C46.3304 45.0308 44.9769 43.6773 44.9769 42.0077V29.9152C44.9769 28.2456 46.3304 26.8921 48 26.8921ZM48 59.1387C50.2262 59.1387 52.0308 57.334 52.0308 55.1078C52.0308 52.8817 50.2262 51.077 48 51.077C45.7738 51.077 43.9692 52.8817 43.9692 55.1078C43.9692 57.334 45.7738 59.1387 48 59.1387Z",
    fill: "#EC6234"
  }))));
};
export default WarrningLimit;